import { IncomingMessage } from 'http'

import { Customer, Organization } from '@leid/api-customers'
import { NextApiRequest } from 'next'
import { NextApiRequestCookies } from 'next/dist/server/api-utils'

import customersClient from 'helpers/clients/customersClient'
import { withSSRContext } from 'utils/amplify/withSSRContext'
import { decryptOrganizationCookie, ORGANIZATION_HASH_COOKIE_NAME } from 'utils/cookies'

export const getLoggedCustomerInfo = async (
  req: NextApiRequest | (IncomingMessage & { cookies: NextApiRequestCookies }),
): Promise<{ customer: Customer | null; organization: Organization | null } | undefined> => {
  const currentCustomer = await getCurrentCustomer(req)
  console.log(`getLoggedCustomerInfo currentCustomer`, currentCustomer)
  if (!currentCustomer) {
    return {
      customer: null,
      organization: null,
    }
  }

  const organizationData = decryptOrganizationCookie(req.cookies[ORGANIZATION_HASH_COOKIE_NAME])
  if (organizationData === undefined) {
    // Error on decryption of data
    return undefined
  }

  if (organizationData === null) {
    return {
      customer: currentCustomer,
      organization: null,
    }
  }

  if (organizationData.customerId !== currentCustomer.id) {
    // Cookies and current customer are not identical - error
    return undefined
  }

  const response = await customersClient.getOrganization(organizationData.organizationId)
  if (!response.success) {
    // Undefined - error happened
    return undefined
  }

  if (!response.data) {
    // Organization not found - error
    return undefined
  }

  return {
    customer: currentCustomer,
    organization: response.data,
  }
}

export const getCurrentCustomer = async (
  req: NextApiRequest | (IncomingMessage & { cookies: NextApiRequestCookies }),
): Promise<Customer | null> => {
  const { Auth } = withSSRContext({ req })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let customer: any | undefined
  try {
    customer = await Auth.currentAuthenticatedUser()
  } catch (err) {
    console.log(`getCurrentCustomer Error on getCurrentCustomer`, err)
    return null
  }

  console.log(`getCurrentCustomer customer`, customer)

  const email = customer?.attributes?.email
  if (!email) {
    console.log(`getCurrentCustomer no email`, customer)
    // No email - no customer
    return null
  }

  const { data: dbCustomers } = await customersClient.getCustomers({ email: email })
  if (!dbCustomers || dbCustomers.rows.length === 0) {
    // No customer - not logged in
    console.log(`getCurrentCustomer customer not found`, email)
    return null
  }
  console.log(`getCurrentCustomer dbCustomers`, JSON.stringify(dbCustomers.rows))
  return dbCustomers.rows[0]
}
